import { computed, type Ref } from 'vue';

/**
 * Splits the query into parties for the chips shown while the reviewer types.
 *
 * The scan does its own parsing and returns the authoritative parties — including
 * which are unsearchable and which words it discounted as role words. This is only
 * the live preview before a run, so it splits and nothing else: a chip that appeared
 * and then disappeared once the results came back would be worse than no chip.
 *
 * Semicolon and new line only. A comma is part of a name — "Big Corporation,
 * Inc." is one party, not two.
 */
const PARTY_DELIMITER = /[;\n]/;

export function useConflictParties(query: Ref<string>) {
  const parties = computed(() =>
    query.value
      .split(PARTY_DELIMITER)
      .map((part) => part.trim())
      .filter(Boolean),
  );

  const partyCount = computed(() => parties.value.length);

  /** Rebuilds the query without one party, keeping new lines as the delimiter. */
  function removeParty(index: number): string {
    const kept = parties.value.filter((_, i) => i !== index);
    return kept.join('\n');
  }

  return { parties, partyCount, removeParty };
}

export default useConflictParties;
